import { isRouteErrorResponse, useRouteError } from 'react-router'
import { Button } from '@/components/ui/Button'
import { StatePanel } from '@/components/ui/StatePanel'
import { useT } from '@/i18n'
import { forceReload, isChunkLoadError } from '@/lib/chunkReload'

/**
 * Route error boundary: replaces React Router's developer error screen. A
 * missing chunk means a newer version was deployed; everything else is an
 * unexpected failure. Both offer a reload.
 */
export function RouteError() {
  const t = useT()
  const error = useRouteError()
  const outdated = isChunkLoadError(error)
  const detail = isRouteErrorResponse(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : undefined
  return (
    <div className="flex min-h-dvh items-center justify-center p-6">
      <StatePanel
        kind={outdated ? 'unavailable' : 'error'}
        title={outdated ? t('errors.states.newVersionTitle') : t('errors.states.crashTitle')}
        description={outdated ? t('errors.states.newVersionText') : detail || t('errors.states.crashText')}
        action={
          <div className="flex gap-2">
            <Button variant="primary" onClick={forceReload}>
              {t('errors.states.reload')}
            </Button>
            <Button onClick={() => window.location.assign('/')}>{t('common.actions.goToDashboard')}</Button>
          </div>
        }
      />
    </div>
  )
}
